import React from 'react'

const Chat_View_Item = () => {
  return (
    <div >
                                        <div  className='fip'>
                                                  <span className=''><i className='ri-image-line'></i></span>
                                                  <span className=''>File Name</span>
                                        </div>
                                        <div  className='fip'>
                                                  <span className=''><i className='ri-file-text-line'></i></span>
                                                  <span className=''>File Name</span>
                                        </div>
                                        <div  className='fip'>
                                                  <span className=''><i className='ri-image-line'></i></span>
                                                  <span className=''>File Name</span>
                                        </div>    
                                        </div> 
  )
}

export default Chat_View_Item